import {
  PROCESS_ORDERS_REQUEST,
  PROCESS_ORDERS_SUCCESS,
  PROCESS_ORDERS_ERROR,
  RESET_PROCESS_ORDERS,
} from "redux/actions/action-type";

const initialState = {
  processOrderResponse: [],
  isProcessOrderLoading: false,
  isProcessOrderSuccess: false,
  isProcessOrderError: false,
};

const processOrdersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PROCESS_ORDERS_REQUEST:
      return {
        ...state,
        isProcessOrderLoading: true,
        isProcessOrderSuccess: false,
        isProcessOrderError: false,
      };
    case PROCESS_ORDERS_SUCCESS:
      return {
        processOrderResponse: payload,
        isProcessOrderLoading: false,
        isProcessOrderSuccess: true,
        isProcessOrderError: false,
      };
    case PROCESS_ORDERS_ERROR:
      return {
        processOrderResponse: payload,
        isProcessOrderLoading: false,
        isProcessOrderSuccess: false,
        isProcessOrderError: true,
      };
    case RESET_PROCESS_ORDERS:
      return initialState;
    default:
      return state;
  }
};

export default processOrdersReducer;
